module.exports = __webpack_public_path__ + "img/example-cafeteria-menu-en.26788895.jpg";